export default __webpack_public_path__ + "static/media/error404.e29a67e2.gif";